/**
 * @generated SignedSource<<2e0f8667c0ca8c0714bbd5425008ad84>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClubSettings_Club$data = {
  readonly clubPolicyLink: string | null | undefined;
  readonly name: string;
  readonly squareLoyaltyProgram?: {
    readonly rewardTiers: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly points: number;
    } | null | undefined> | null | undefined;
    readonly status: string | null | undefined;
    readonly terminologyOne: string;
    readonly terminologyOther: string;
  } | null | undefined;
  readonly supportsPublic: boolean;
  readonly timeZone?: string;
  readonly " $fragmentSpreads": FragmentRefs<"CurrentPackagesModal_club" | "useClubHasMemberships_club" | "useClubHasPackages_club">;
  readonly " $fragmentType": "ClubSettings_Club";
};
export type ClubSettings_Club$key = {
  readonly " $data"?: ClubSettings_Club$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClubSettings_Club">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "patronLoyalty"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClubSettings_Club",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clubPolicyLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportsPublic",
      "storageKey": null
    },
    {
      "condition": "patronLoyalty",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timeZone",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SquareLoyaltyProgram",
          "kind": "LinkedField",
          "name": "squareLoyaltyProgram",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "terminologyOne",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "terminologyOther",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SquareLoyaltyRewardTier",
              "kind": "LinkedField",
              "name": "rewardTiers",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "points",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CurrentPackagesModal_club"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useClubHasMemberships_club"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useClubHasPackages_club"
    }
  ],
  "type": "Club",
  "abstractKey": null
};
})();

(node as any).hash = "f3e533d60fe73c532ba0108347fd1d09";

export default node;
